import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Layout from "layouts/DashboardManage";
import {
  getDepartment,
  updateDepartment
} from "store/actions/departmentAction";
import has from "lodash/has";
import { notifyApiError } from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import Textbox from "components/Forms/Elements/Textbox";
import { SpinnerSyncBlock } from "components/Spinner";
import Translate from "helpers/Translate";

export class Edit extends Component {
  state = {
    name: "",
    items: []
  };

  componentDidMount() {
    this.props.getDepartment(this.props.match.params.departmentId);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.department !== this.props.department &&
      has(this, "props.department.name")
    ) {
      this.setState({
        name: this.props.department.name,
        items: this.props.department.items
      });
    }

    // When the new department is updated successfully, we will redirect to listing page
    if (
      prevProps.updateDepartmentResponse !==
        this.props.updateDepartmentResponse &&
      has(this, "props.updateDepartmentResponse.id")
    ) {
      // Redirect to manage page
      this.props.history.push(`/manage/departments`);
    }

    // When there was a problem updating the department
    if (
      prevProps.errorDepartment !== this.props.errorDepartment &&
      this.props.errorDepartment &&
      Object.keys(this.props.errorDepartment).length > 0
    ) {
      notifyApiError(this.props.errorDepartment);
    }
  }

  handleChange = e => {
    e.persist();
    if ("itemIdx" in e) {
      let newValue = e.target.value;
      if (e.target.id === "value") {
        newValue = newValue.replace(/[^a-z0-9_-]/gi, "");
      }
      this.setState(prevState => {
        prevState.items[e.itemIdx] = {
          ...prevState.items[e.itemIdx],
          [e.target.name]: newValue
        };
        return prevState;
      });
    } else {
      this.setState(prevState => ({
        ...prevState,
        [e.target.name]: e.target.value
      }));
    }
  };

  handleUpdate = () => {
    this.props.updateDepartment({
      id: this.props.match.params.departmentId,
      data: {
        name: this.state.name,
        items: this.state.items
      }
    });
  };

  render() {
    return (
      <Layout>
        {this.props.isLoading && <SpinnerSyncBlock />}
        <div className="add-edit">
          <h1 className="title mb-30">
            {Translate({ id: "edit_collection" })}{" "}
          </h1>
          <div className="center-form">
            <div className="form-wrapper mb-20">
              <div className="form-group">
                <label htmlFor="name">
                  {Translate({ id: "collection_name" })} :
                </label>
                <Textbox
                  type="text"
                  placeholder={Translate({ id: "certificates_and_degrees" })}
                  id="name"
                  name="name"
                  fieldValue={this.state.name}
                  onChange={this.handleChange}
                  onReturnKey={this.handleUpdate}
                  errors={this.props.errorDepartment}
                  errorKey="name"
                  formErrorClass="form-error"
                />
              </div>

              <hr className="my-20" />

              {this.state.items.length ? (
                <div className="help mt-10 mb-20">
                  {Translate({
                    id: "item_value_can_only_contain_alphanumeric_chars_and_underscore"
                  })}
                </div>
              ) : null}

              {this.state.items &&
                this.state.items.map((item, idx) => (
                  <div key={idx} className="key-value mb-10">
                    <div className="form-group mr-20">
                      <label htmlFor="title">
                        {Translate({ id: "item_title" })} :
                      </label>
                      <Textbox
                        type="text"
                        id="title"
                        name="title"
                        fieldValue={item.title}
                        onChange={e => {
                          e.itemIdx = idx;
                          this.handleChange(e);
                        }}
                        onReturnKey={this.handleUpdate}
                        errors={this.props.errorDepartment}
                        errorKey={`items.${idx}.title`}
                        formErrorClass="form-error"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="value">
                        {Translate({ id: "item_value" })}:
                      </label>
                      <Textbox
                        type="text"
                        id="value"
                        name="value"
                        fieldValue={item.value}
                        onChange={e => {
                          e.itemIdx = idx;
                          this.handleChange(e);
                        }}
                        onReturnKey={this.handleUpdate}
                        errors={this.props.errorDepartment}
                        errorKey={`items.${idx}.value`}
                        formErrorClass="form-error"
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="value">&nbsp;</label>
                      <i
                        className="fas fa-trash-alt ml-10 mt-5 pointer"
                        onClick={() => {
                          this.setState(prevState => {
                            prevState.items.splice(idx, 1);
                            return prevState;
                          });
                        }}
                      ></i>
                    </div>
                  </div>
                ))}

              <button
                className="btn btn-default btn-sm fr mt-10"
                data-test="btnaddmore"
                onClick={() => {
                  this.setState(prevState => ({
                    ...prevState,
                    items: [
                      ...prevState.items,
                      {
                        title: "",
                        value: ""
                      }
                    ]
                  }));
                }}
              >
                <i className="fas fa-plus-circle"></i>{" "}
                {Translate({ id: "add_more" })}
              </button>
              <div className="clear mb-10"></div>

              <div className="alert alert-info">
                <p>
                  {Translate({
                    id: "a_collection_can_have_various_departments_of_a_client_one_collection_can_have_multiple_departments"
                  })}
                </p>
              </div>
            </div>
          </div>
          <div className="save-cancel-buttons">
            <Link
              to="/manage/departments"
              className="btn manage-btn-cancel"
            >
              <i className="far fa-times-circle mr-10"></i> {Translate({ id: "cancel" })}
            </Link>

            <SubmitButton
              className="btn btn-primary manage-btn-save"
              buttonIconClass="fas fa-save mr-10"
              buttonText={Translate({ id: "save_changes" })}
              btnId="update"
              isLoading={this.props.isLoading}
              handleSubmit={this.handleUpdate}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

Edit.propTypes = {
  updateDepartment: PropTypes.func.isRequired,
  getDepartment: PropTypes.func,
  department: PropTypes.object,
  updateDepartmentResponse: PropTypes.object,
  errorDepartment: PropTypes.object,
  isLoading: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    department: state.department.getDepartment,
    updateDepartmentResponse: state.department.updateDepartment,
    errorDepartment: state.department.errorDepartment,
    isLoading: state.department.isLoadingDepartment
  };
};

export default connect(mapStateToProps, {
  getDepartment: getDepartment,
  updateDepartment: updateDepartment
})(Edit);
